/* CSN editorial: reveal-on-scroll, hero parallax, product rail controls. Tiny, vanilla, deferred. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Reveal on scroll. Content is never hidden at rest: an element is only set to its start state
  // (class csn-wait) when it comes near the bottom of the viewport, then .is-in plays the reveal.
  // Elements already on screen (or close) at load are shown at once. No JS, reduced motion,
  // print and full-page captures therefore always show everything.
  function initReveal(root) {
    var els = (root || document).querySelectorAll('[data-csn-reveal]:not(.is-in)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var seen = new WeakSet();
    var show = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); show.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.01 });
    var near = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var el = e.target;
        if (!seen.has(el)) {
          seen.add(el);
          // First report: on screen or close to it now, so show without motion.
          if (e.isIntersecting) { el.classList.add('is-in'); near.unobserve(el); return; }
          return;
        }
        if (e.isIntersecting && e.boundingClientRect.top > 0) {
          el.classList.add('csn-wait');
          near.unobserve(el);
          show.observe(el);
        }
      });
    }, { rootMargin: '0px 0px 25% 0px', threshold: 0 });
    els.forEach(function (el) { near.observe(el); });
    window.addEventListener('beforeprint', function () {
      document.querySelectorAll('[data-csn-reveal]').forEach(function (el) { el.classList.add('is-in'); });
    });
  }

  function initParallax() {
    if (reduce) return;
    var stages = document.querySelectorAll('[data-csn-parallax]');
    if (!stages.length) return;
    var ticking = false;
    function update() {
      ticking = false;
      stages.forEach(function (s) {
        var r = s.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        var y = Math.max(-40, Math.min(40, -r.top * 0.12));
        s.style.setProperty('--csn-py', y.toFixed(1) + 'px');
      });
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  // Hero v6: load the right video for the screen after the page has loaded, fade it in, pause button.
  function initHero6() {
    var hero = document.querySelector('[data-csn-hero6]');
    if (!hero || reduce) return;
    var conn = navigator.connection || {};
    if (conn.saveData) return;
    var mobile = window.matchMedia('(max-width: 749px)').matches;
    var v = hero.querySelector('[data-csn-hv="' + (mobile ? 'm' : 'd') + '"]') || hero.querySelector('[data-csn-hv]');
    if (!v) return;
    var srcs = Array.prototype.slice.call(v.querySelectorAll('source[data-src]'));
    if (!srcs.length) return;
    var want = mobile ? 720 : 1080;
    srcs.sort(function (a, b) { return Math.abs((+a.dataset.h || 0) - want) - Math.abs((+b.dataset.h || 0) - want); });
    var start = function () {
      v.src = srcs[0].dataset.src; v.muted = true;
      v.addEventListener('playing', function () { v.classList.add('is-playing'); }, { once: true });
      var p = v.play(); if (p && p.catch) p.catch(function () {});
    };
    if (document.readyState === 'complete') setTimeout(start, 200); else window.addEventListener('load', function () { setTimeout(start, 200); });
    var btn = hero.querySelector('[data-csn-hv-toggle]');
    if (btn) btn.addEventListener('click', function () {
      if (v.paused) { v.play(); btn.setAttribute('aria-pressed', 'false'); btn.setAttribute('aria-label', 'Pause background video'); }
      else { v.pause(); btn.setAttribute('aria-pressed', 'true'); btn.setAttribute('aria-label', 'Play background video'); }
    });
  }

  // Hero v5: rotate the best-seller card every 4.5 s (pauses on hover/focus and when off screen).
  function initHeroCards() {
    document.querySelectorAll('[data-csn-hero-cards]').forEach(function (wrap) {
      var cards = wrap.querySelectorAll('[data-csn-hcard]');
      var dots = wrap.querySelectorAll('.csn-hcard__dots i');
      if (cards.length < 2 || reduce) return;
      var i = 0, paused = false, visible = true;
      function show(n) {
        cards[i].classList.remove('is-active'); cards[i].setAttribute('aria-hidden', 'true'); cards[i].tabIndex = -1;
        if (dots[i]) dots[i].classList.remove('is-active');
        i = n % cards.length;
        cards[i].classList.add('is-active'); cards[i].removeAttribute('aria-hidden'); cards[i].removeAttribute('tabindex');
        if (dots[i]) dots[i].classList.add('is-active');
      }
      wrap.addEventListener('mouseenter', function () { paused = true; });
      wrap.addEventListener('mouseleave', function () { paused = false; });
      wrap.addEventListener('focusin', function () { paused = true; });
      wrap.addEventListener('focusout', function () { paused = false; });
      if ('IntersectionObserver' in window) new IntersectionObserver(function (e) { visible = e[0].isIntersecting; }).observe(wrap);
      setInterval(function () { if (!paused && visible && !document.hidden) show(i + 1); }, 4500);
    });
  }

  // Hero v4: fade the looping video in once it really plays (the photo stays underneath as the fallback).
  function initHeroVideo() {
    document.querySelectorAll('.csn-hero4--video video').forEach(function (v) {
      v.muted = true; v.setAttribute('playsinline', '');
      var show = function () { v.classList.add('is-playing'); };
      v.addEventListener('playing', show, { once: true });
      if (reduce) { v.pause(); return; }
      var p = v.play(); if (p && p.catch) { p.catch(function () {}); }
    });
  }

  // Hero v3 (kept for the editor): the scattered cut-outs drift a little with the mouse.
  function initHeroMouse() {
    if (reduce || !window.matchMedia('(hover: hover) and (min-width: 990px)').matches) return;
    var hero = document.querySelector('[data-csn-hero]');
    var field = hero && hero.querySelector('[data-csn-field]');
    if (!field) return;
    var raf = false, mx = 0, my = 0;
    hero.addEventListener('mousemove', function (e) {
      var r = hero.getBoundingClientRect();
      mx = ((e.clientX - r.left) / r.width - 0.5) * 2;
      my = ((e.clientY - r.top) / r.height - 0.5) * 2;
      if (!raf) { raf = true; requestAnimationFrame(function () { raf = false; field.style.setProperty('--mx', (-mx).toFixed(3)); field.style.setProperty('--my', (-my).toFixed(3)); }); }
    }, { passive: true });
    hero.addEventListener('mouseleave', function () { field.style.setProperty('--mx', '0'); field.style.setProperty('--my', '0'); });
  }

  function initRails(root) {
    (root || document).querySelectorAll('[data-csn-rail]').forEach(function (rail) {
      if (rail.dataset.csnReady) return;
      rail.dataset.csnReady = '1';
      var track = rail.querySelector('.csn-rail__track');
      var prev = rail.querySelector('.csn-rail__btn--prev');
      var next = rail.querySelector('.csn-rail__btn--next');
      var bar = rail.querySelector('.csn-rail__progress');
      if (!track) return;
      function step() {
        var item = track.querySelector(':scope > li');
        return item ? item.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
      }
      function update() {
        var max = track.scrollWidth - track.clientWidth;
        var vis = track.scrollWidth ? track.clientWidth / track.scrollWidth : 1;
        var p = max > 0 ? track.scrollLeft / max : 1;
        if (bar) bar.style.setProperty('--p', Math.min(1, vis + (1 - vis) * p).toFixed(3));
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max - 2;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step() * 2, behavior: reduce ? 'auto' : 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step() * 2, behavior: reduce ? 'auto' : 'smooth' }); });
      track.addEventListener('scroll', function () { requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  function initMore(root) {
    (root || document).querySelectorAll('[data-csn-more]').forEach(function (box) {
      var btn = box.querySelector('.csn-coll__more');
      if (!btn || btn.dataset.csnReady) return;
      btn.dataset.csnReady = '1';
      btn.addEventListener('click', function () {
        var open = box.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  // Sub-collection chips: on a child collection, bring the active chip into view inside its row.
  function initSubcoll(root) {
    (root || document).querySelectorAll('.subcoll__track').forEach(function (track) {
      var active = track.querySelector('.is-active');
      if (!active || track.scrollWidth <= track.clientWidth) return;
      var left = active.offsetLeft - track.offsetLeft;
      if (left + active.offsetWidth > track.clientWidth - 48) track.scrollLeft = Math.max(0, left - 16);
    });
  }


  // Polish 2026-10-11: keep short hyphenated words (Pre-Workout, L-Citrulline) whole in titles,
  // so a line never ends in "Pre-". If a kept word is wider than its box, it may break again.
  var NW_SEL = '.csn-lede, .card__heading, .csn-tile__title, .csn-own__name, .cart-item__name, .predictive-search__item-heading, .csn-addon__title, h1, h2, h3';
  var NW_RE = /(\S*[A-Za-z0-9]-[A-Za-z0-9]\S*)/;
  function blockOf(el) { while (el && getComputedStyle(el).display.indexOf('inline') === 0) el = el.parentElement; return el; }
  function keepHyphens(root) {
    (root || document).querySelectorAll(NW_SEL).forEach(function (el) {
      if (el.dataset.csnNw) return;
      el.dataset.csnNw = '1';
      var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT), nodes = [], n;
      while ((n = walker.nextNode())) if (NW_RE.test(n.nodeValue) && !n.parentElement.closest('.csn-nw,script,style')) nodes.push(n);
      nodes.forEach(function (t) {
        var parts = t.nodeValue.split(NW_RE), frag = document.createDocumentFragment(), any = false;
        parts.forEach(function (s, i) {
          if (!s) return;
          if (i % 2 && s.length <= 16) { var sp = document.createElement('span'); sp.className = 'csn-nw'; sp.textContent = s; frag.appendChild(sp); any = true; }
          else frag.appendChild(document.createTextNode(s));
        });
        if (any) t.parentNode.replaceChild(frag, t);
      });
      el.querySelectorAll('.csn-nw').forEach(function (sp) {
        var box = blockOf(sp.parentElement);
        if (box && box.clientWidth && sp.offsetWidth > box.clientWidth) sp.classList.add('csn-nw--off');
      });
    });
  }
  function watchHyphens() {
    keepHyphens();
    if (!('MutationObserver' in window)) return;
    var t = null;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { keepHyphens(); }, 120); })
      .observe(document.body, { childList: true, subtree: true });
  }

  function init(root) { initReveal(root); initRails(root); initMore(root); initSubcoll(root); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); initParallax(); initHeroMouse(); initHeroVideo(); initHeroCards(); initHero6(); watchHyphens(); });
  } else { init(); initParallax(); initHeroMouse(); initHeroVideo(); initHeroCards(); initHero6(); watchHyphens(); }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
